import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
export var mobileSuburbStats = {
  name: "j7qwjs",
  styles: "display:flex;flex-direction:column;"
};
export var medianPrice = {
  name: "uewl2b",
  styles: "margin-bottom:20px;"
};
export var link = {
  name: "1mgro8i",
  styles: "padding-left:0;padding-right:10px;> div > div:first-of-type{height:unset;}"
};
export var articles = {
  name: "178yklu",
  styles: "margin-top:24px;"
};
export var linkText = /*#__PURE__*/css(designTokenFonts.body, " color:", colors.interactive.base.default, ";");
export var linkIcon = /*#__PURE__*/css("color:", colors.interactive.base.default, ";");
export var ctaCard = {
  name: "uewl2b",
  styles: "margin-bottom:20px;"
};